import {
  StripeCardCvcElementOptions,
  StripeCardExpiryElementOptions,
  StripeCardNumberElementOptions,
  StripeElementStyleVariant,
} from '@stripe/stripe-js';

const commonStyle: StripeElementStyleVariant = {
  fontFamily: 'Source Sans Pro, sans-serif',
  fontWeight: '500',
  fontStyle: 'bold',
  fontSize: '16px',
};

export const CARD_NUMBER_OPTIONS: StripeCardNumberElementOptions | undefined = {
  placeholder: 'Card Number',
  style: {
    base: { ...commonStyle },
  },
  classes: { base: 'stripe-form-input', focus: 'stripe-form-input-focus' },
};

export const CARD_DATE_OPTIONS: StripeCardExpiryElementOptions | undefined = {
  style: {
    base: { ...commonStyle },
  },
  classes: { base: 'stripe-form-input', focus: 'stripe-form-input-focus' },
};

export const CARD_CVC_OPTIONS: StripeCardCvcElementOptions | undefined = {
  style: {
    base: { ...commonStyle },
  },
  classes: { base: 'stripe-form-input', focus: 'stripe-form-input-focus' },
};
